import {httpRequest} from "./http-request";

export const distributionCenterService = {
  getCompanies,
  edit,
  getOrderTimeSums,
  deleteOrderTimeSum,
  addOrderTimeSum,
  create,
  getCompaniesOnApproveOrderCreate,
  getGates,
  addGate,
  editGate,
  getLoadingSchedule,
  getUnloadingTimeSettings,
  saveUnloadingTimeSettings
};


/**
 * Получить список компаний принадлежащих пользователю
 */
async function getCompanies(fullList = false, columnSort = false, consignorId = null, shipperCompanyId = null, friendly = null) {

  return await httpRequest.get('distribution-center/list?FullList='+ fullList +'&ColumnSort='+ columnSort +'&ConsignorId='+ consignorId +'&ShipperCompanyId='+ shipperCompanyId + '&Friendly=' + friendly)
    .then((response) => {

      if (response.status === 200 && typeof response.data !== "undefined") {
        return Promise.resolve(response.data);
      }

      return Promise.reject(httpRequest.getDefaultMessageError());
    });
}

/**
 * Получить список компаний для создания заявки на подтверждение юр.лица
 */
async function getCompaniesOnApproveOrderCreate(legalEntityId, consignorId) {

  return await httpRequest.get('distribution-center/list-for-approve-order-create?LegalEntityId=' + legalEntityId + '&ConsignorId=' + consignorId)
      .then((response) => {

        if (response.status === 200 && typeof response.data !== "undefined") {
          return Promise.resolve(response.data);
        }

        return Promise.reject(httpRequest.getDefaultMessageError());
      });
}

/**
 * Изменить информацию о РЦ
 */
async function edit(
  id,
  delayDelivDispatcher,
  delayReserveDeliv,
  maxCountLoadAuto,
  startFillingOrder,
  fillingOrder,
  downloadDocument,
  closingTime,
  minOrdersToApprove,
  minHoursToRefuse,
  cargoCollectTime,
  importantDeliveryMaxTimeLoad,
  countSkipAvailableTimesNonImportantDelivery,
  maxInnerDistance,
) {

  return await httpRequest.patch(`distribution-center/${id}/edit`, {
    delayDelivDispatcher: delayDelivDispatcher,
    delayReserveDeliv: delayReserveDeliv,
    maxCountLoadAuto: maxCountLoadAuto,
    startFillingOrder: startFillingOrder,
    fillingOrder: fillingOrder,
    downloadDocument: downloadDocument,
    closingTime: closingTime,
    minOrdersToApprove: minOrdersToApprove,
    minHoursToRefuse: minHoursToRefuse,
    cargoCollectTime: cargoCollectTime,
    importantDeliveryMaxTimeLoad: importantDeliveryMaxTimeLoad,
    countSkipAvailableTimesNonImportantDelivery: countSkipAvailableTimesNonImportantDelivery,
      maxInnerDistance: maxInnerDistance,
  })
    .then((response) => {

      if (response.status === 200) {
        return Promise.resolve(response.data);
      }

      return Promise.reject(httpRequest.getDefaultMessageError());
    });
}

/**
 * Список настроек соотношения надбавочной суммы и кол-ва прошедших часов
 * @param distCenterId
 * @returns {Promise<*>}
 */
async function getOrderTimeSums(distCenterId) {

  return await httpRequest.post('distribution-center/get-order-sum-time-list', {
    DistributionCenter: distCenterId
  })
    .then((response) => {

      if (response.status === 200 && typeof response.data !== "undefined") {
        return Promise.resolve(response.data);
      }

      return Promise.reject(httpRequest.getDefaultMessageError());
    });
}

/**
 * Удаляет запись по id
 * @param id
 * @returns {Promise<*>}
 */
async function deleteOrderTimeSum(id) {

  return await httpRequest.post('distribution-center/delete-order-sum-time', {
    id: id
  })
    .then((response) => {

      if (response.status === 200 && typeof response.data !== "undefined") {
        return Promise.resolve(response.data);
      }

      return Promise.reject(httpRequest.getDefaultMessageError());
    });
}

/**
 * Добавляет новую запись
 * @param distCenterId
 * @param time
 * @param sum
 * @returns {Promise<*>}
 */
async function addOrderTimeSum(distCenterId, time, sum) {

  return await httpRequest.post('distribution-center/add-order-sum-time', {
    DistributionCenterId: distCenterId,
    Time: time,
    Sum: sum,
  })
    .then((response) => {

      if (response.status === 200 && typeof response.data !== "undefined") {
        return Promise.resolve(response.data);
      }

      return Promise.reject(httpRequest.getDefaultMessageError());
    });
}


/**
 * Список настроек разгрузки
 * @param distCenterId
 * @returns {Promise<*>}
 */
async function getUnloadingTimeSettings(distCenterId) {

  return await httpRequest.post('distribution-center/get-unloading-time-settings', {
    DistributionCenter: distCenterId
  })
    .then((response) => {

      if (response.status === 200 && typeof response.data !== "undefined") {
        return Promise.resolve(response.data);
      }

      return Promise.reject(httpRequest.getDefaultMessageError());
    });
}

/**
 * Добавляет новую запись
 * @param distCenterId
 * @param time
 * @param sum
 * @returns {Promise<*>}
 */
async function saveUnloadingTimeSettings(distCenterId, data) {

  return await httpRequest.post('distribution-center/save-unloading-settings', {
    DistributionCenterId: distCenterId,
    Data: data,
  })
    .then((response) => {

      if (response.status === 200 && typeof response.data !== "undefined") {
        return Promise.resolve(response.data);
      }

      return Promise.reject(httpRequest.getDefaultMessageError());
    });
}


async function create(
  name,
  shipperCompanyId,
  delayDelivDispatcher,
  delayReserveDeliv,
  maxCountLoadAuto,
  startFillingOrder,
  fillingOrder,
  downloadDocument,
  closingTime,
  minOrdersToApprove,
  minHoursToRefuse
) {

  return await httpRequest.patch(`distribution-center/create`, {
    name: name,
    shipperCompanyId: shipperCompanyId,
    delayDelivDispatcher: delayDelivDispatcher,
    delayReserveDeliv: delayReserveDeliv,
    maxCountLoadAuto: maxCountLoadAuto,
    startFillingOrder: startFillingOrder,
    fillingOrder: fillingOrder,
    downloadDocument: downloadDocument,
    closingTime: closingTime,
    minOrdersToApprove: minOrdersToApprove,
    minHoursToRefuse: minHoursToRefuse
  })
    .then((response) => {

      if (response.status === 200) {
        return Promise.resolve(response.data);
      }

      return Promise.reject(httpRequest.getDefaultMessageError());
    });
}

/**
 * Получить список ворот РЦ
 */
async function getGates(id, type, withoutVirtuals) {
  let url = `distribution-center/get-gates?id=${id}`;
  if (type != null) {
    url+=`&type=${type}`;
  }
  if (withoutVirtuals != null) {
    url+=`&withoutVirtuals=${withoutVirtuals}`;
  }
  return await httpRequest.get(url)
    .then((response) => {

      if (response.status === 200 && typeof response.data !== "undefined") {
        return Promise.resolve(response.data);
      }

      return Promise.reject(httpRequest.getDefaultMessageError())
    })
}


/**
 * Добавляет новые ворота РЦ
 * @param id
 * @param isActive
 * @param name
 * @param serviceTime
 * @param workingDays
 * @returns {Promise<*>}
 */
async function addGate(id, isActive, name, serviceTime, workingDays = [], type, maxCargoWeight, realGateId) {
  return await httpRequest.post('distribution-center/create-gate?id=' + id, {
    name: name,
    isActive: isActive,
    serviceTime: serviceTime,
    workingDays: workingDays,
    type: type,
    maxCargoWeight: maxCargoWeight,
    realGateId: realGateId
  })
    .then((response) => {

      if (response.status === 200 && typeof response.data !== "undefined") {
        return Promise.resolve(response.data);
      }

      return Promise.reject(httpRequest.getDefaultMessageError());
    });
}

async function editGate(id, isActive, name, serviceTime, workingDays = [], type, maxCargoWeight, realGateId) {
  return await httpRequest.post('distribution-center/edit-gate?gateID=' + id, {
    name: name,
    isActive: isActive,
    serviceTime: serviceTime,
    workingDays: workingDays, 
    type: type,
    maxCargoWeight: maxCargoWeight,
    realGateId: realGateId
  })
    .then((response) => {

      if (response.status === 200 && typeof response.data !== "undefined") {
        return Promise.resolve(response.data);
      }

      return Promise.reject(httpRequest.getDefaultMessageError());
    });
}


async function getLoadingSchedule(distCenterId, date, search, gateType) {
  let url = 'distribution-center/get-loading-schedule?id=' + distCenterId;
  if (date != null) {
    url += `&date=${date}`;
  }
  if (gateType !== undefined) {
    url += `&gateType=${gateType}`;
  } 
  url += `&search=${search}`;
  return await httpRequest.get(url)
    .then((response) => {

      if (response.status === 200 && typeof response.data !== "undefined") {
        return Promise.resolve(response.data);
      }

      return Promise.reject(httpRequest.getDefaultMessageError());
    });
}